import React, { Component } from 'react';
import Slider from "react-slick";
import ProductCard from '../product/ProductCard';
import '../productList/ProductListStyles.css'
import prod from '../../Products';

class ProductSlider extends Component {
    render() {
        const settings = {
            dots: false,
            infinite: true,
            slidesToShow: 3,
            slidesToScroll: 1,
            autoplay: true,
            speed: 1000,
            autoplaySpeed: 1000,
            cssEase: "linear",
            focusOnSelect: true,
            arrows: true,
            fade: false,
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3,
                        infinite: true,
                        dots: true
                    }
                },
                {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2,
                        initialSlide: 2
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }
            ]
        };
        return (
            <div className="container">
                <div className="container">
                    <Slider {...settings}>


                        {
                            prod.map((ob, key) => {
                                return (
                                    <div className="grid" key={key}>
                                        <ProductCard obj={ob} />
                                    </div >
                                );
                            })
                        }





                    </Slider>
                </div>

            </div>
        );
    }
}

export default ProductSlider;
